<template>
  <b-modal
    v-model="modalShow"
    hide-footer
    hide-header
    centered
    :dialog-class="
      onboardingState == 3 ? 'vf-max-w-[620px]' : 'vf-max-w-[720px]'
    "
    no-close-on-backdrop
    class="v-modal-custom"
  >
    <div
      :class="`${
        onboardingState == 1
          ? 'modal-body-onboarding mx-auto text-center py-3'
          : 'modal-body-survey py-2'
      }`"
    >
      <WelcomeModal
        v-if="onboardingState == 1"
        @on-state-change="onboardingState = 2"
      />

      <SurveyModal
        v-else-if="onboardingState == 2"
        @on-state-change="onboardingState = 3"
      />

      <SurveyAnsweredModal v-else-if="onboardingState == 3" />
    </div>
  </b-modal>
</template>

<script setup>
import { ref, inject, onBeforeMount } from "vue";
import WelcomeModal from "@/views/dashboard/components/onboarding/WelcomeModal.vue";
import SurveyModal from "@/views/dashboard/components/onboarding/SurveyModal.vue";
import SurveyAnsweredModal from "@/views/dashboard/components/onboarding/SurveyAnsweredModal.vue";

const modalShow = ref(false);
const emitter = inject("emitter");
const onboardingState = ref();

emitter.on("workspaceOnboardingModal:value", (show) => {
  modalShow.value = show;
});

onBeforeMount(() => {
  const isWelcome = window.localStorage.getItem("_welcome");
  onboardingState.value = !isWelcome ? 2 : 1;
});
</script>

<style computed>
.modal-body-onboarding {
  width: 60%;
}

@media (max-width: 768px) {
  .modal-body-onboarding {
    width: 100% !important;
  }
}

@media (max-width: 992px) {
  .modal-body-onboarding {
    width: 80% !important;
  }
}
</style>
